var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 30,
    viewBox: "0 0 101 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.3887 16.2692C69.3887 15.4151 69.6979 14.6759 70.3164 14.0517C70.9349 13.4275 71.6673 13.1154 72.5137 13.1154C73.36 13.1154 74.0924 13.4275 74.7109 14.0517C75.3294 14.6759 75.6387 15.4151 75.6387 16.2692C75.6387 17.1234 75.3294 17.8626 74.7109 18.4868C74.0924 19.111 73.36 19.4231 72.5137 19.4231C71.6673 19.4231 70.9349 19.111 70.3164 18.4868C69.6979 17.8626 69.3887 17.1234 69.3887 16.2692ZM100.639 63.5769V69.8846H88.1387V82.5H81.8887V69.8846H69.3887V63.5769H81.8887V50.9615H88.1387V63.5769H100.639ZM45.6582 47.8077L63.1387 65.4002V69.8846H0.638672V0.5H88.1387V44.6538H81.8887V6.80769H6.88867V27.5541L16.2637 18.1418L41.2637 43.3726L53.7637 30.7572L75.6387 52.7849V57.2692H71.1953L53.7637 39.6274L45.6582 47.8077ZM16.2637 27.012L6.88867 36.5228V63.5769H52.4453L16.2637 27.012Z",
    fill: "#868686"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.2d969a3957734c6319f791240a6d5d08.svg";
export { ForwardRef as ReactComponent };